import React from 'react'
import { graphql } from 'gatsby'

import BackgroundVideo from '../components/BackgroundVideo'
import CategoriesNav from '../components/CategoriesNav'
import PostSection from '../components/PostSection'
import { MDXContent } from '../components/Content'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import Card from '../components/Card'
import '../components/MiniPosts.css'
import './HomePage.css'
import { brandDesignNav, brandServices } from '../commons'

// Export Template for use in CMS preview
export const HomePageTemplate = ({
  body,
  video,
  slug,
  title,
  subtitle,
  featuredImage,
  sectionOne = [],
  sectionTwo = [],
  videoPoster,
  videoTitle,
  videoContent,
  videoText,
  content,
  posts = [],
  showStories,
  subNav,
  meta
}) => {
  let categories = []
  let categoryTitle = meta.title || ''

  if (brandServices.includes(slug)) {
    categoryTitle = 'Brand Design'
    slug = 'brand-design'
    categories = brandDesignNav
  }

  return (
    <main className="Home">
      {subNav && (
        <section className="Nav--Container container">
          <CategoriesNav
            indexName={categoryTitle}
            indexSlug={slug}
            categories={categories}
            hire={true}
          />
        </section>
      )}

      {title && (
        <PageHeader
          large
          title={title}
          subtitle={subtitle}
          backgroundImage={featuredImage}
        />
      )}

      {!!sectionOne && (
        <section className="section">
          <div className="container">
            {sectionOne.map(item => (
              <Card
                type="Max"
                slug={item.slug}
                title={item.title}
                content={item.content}
                slugText={item.slugText}
                featuredImage={item.featuredImage}
              />
            ))}
          </div>
        </section>
      )}

      {!!video && (
        <section className="section">
          <section className="BackgroundVideo-section">
            <BackgroundVideo
              poster={videoPoster}
              videoContent={videoContent}
              videoText={videoText}
              videoTitle={videoTitle}
            >
              {video && <source src={video} type="video/mp4" />}
            </BackgroundVideo>
          </section>
        </section>
      )}

      {!!content && (
        <section className="section">
          <div className="container">
            <div className="HomePage--Content">
              <MDXContent source={content} />
            </div>
          </div>
        </section>
      )}

      {!!sectionTwo && (
        <section className="section">
          <div className="container">
            {sectionTwo.map(item => (
              <Card
                type="Max"
                slug={item.slug}
                title={item.title}
                content={item.content}
                slugText={item.slugText}
                featuredImage={item.featuredImage}
              />
            ))}
          </div>
        </section>
      )}

      {showStories && !!posts.length && (
        <section className="section">
          <div className="container">
            <header>
              <h3 className="MiniPosts--title">Stories</h3>
            </header>
            <PostSection
              postLimit={6}
              showLoadMore={false}
              mainPost={false}
              posts={posts}
            />
          </div>
        </section>
      )}
    </main>
  )
}

// Export Default HomePage for front-end
const HomePage = ({ data: { page, posts } }) => {
  return (
    <Layout meta={page.frontmatter.meta || false}>
      <HomePageTemplate
        {...page}
        {...page.frontmatter}
        posts={posts.edges.map(post => ({
          ...post.node,
          ...post.node.frontmatter,
          ...post.node.fields
        }))}
        body={page.body}
      />
    </Layout>
  )
}

export default HomePage

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query HomePage($id: String!) {
    page: mdx(id: { eq: $id }) {
      ...Meta
      body
      frontmatter {
        slug
        title
        subtitle
        featuredImage
        subNav
        sectionOne {
          featuredImage
          content
          slug
          slugText
          title
        }
        video
        videoPoster
        videoTitle
        videoContent
        videoText
        excerpt
        content
        sectionTwo {
          featuredImage
          content
          slug
          slugText
          title
        }
        showStories
      }
    }

    posts: allMdx(
      filter: { fields: { contentType: { eq: "stories" } } }
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            date
            categories {
              category
            }
            featuredImage
          }
        }
      }
    }
  }
`
